export default __webpack_public_path__ + "static/steel-a08c0e419c05b0e43a2acc22e5e6c251.jpg";